import React from "react";
import styles from "./ubung.module.scss";

const Ubung = ({ ubung = {}, _onClick }) => {
//console.log(ubung.url);
    return (
        <>
            <iframe loading={`lazy`} src={ubung.url} className={styles.ubungframe} allowFullScreen={`allowfullscreentitle`} title={ubung.title}></iframe>
        </>
    );

}

export default Ubung;